/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: ProductsPage
 * Page name: products page
 * Page Description: This is the products page of the website of Ekathva Innovations, it consists of all the
 *  details about the company products.
 */

import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import LandingPageProducts from "components/Headers/LandingPageProducts";
import Navbar from "components/Navbars/Navbar";
import Footer from "components/Footers/Footer";
import { Formik, Form } from "formik";
import Validation from "../Validation.js";
import ApiService from "../api/ApiService.js";

import "assets/style/Style.css";
import successImage from "assets/images/AllPage/list.png";
import failureImage from "assets/images/AllPage/into.png";

import SmartValve from "./Products/SmartValve";

class ProductsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal_order: false,
      modal_success: false,
      modal_failure: false,
      name: "",
      productId: "",
      quantity: "",
      emailAddress: "",
      contactNumber: "",
      shippingAddress: "",
      billingAddress: "",
      productError: "",
      quantityError: "",
    };

    this.onOrderSubmit = this.onOrderSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    // this is needed, because InfiniteCalendar forces window scroll
    window.scrollTo(0, 0);
  }

  toggle = (modalType) => () => {
    console.log("inside toggle");
    if (!modalType) {
      return this.setState({ modal: !this.state.modal });
    }
    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  }

  onKeyPressTextOnly(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressTextOnly(event);
    }
  }
  onKeyPressNumberOnly(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressNumberOnly(event);
    }
  }
  onKeyPressRetrisctSomeSC(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressRetrisctSomeSC(event);
    }
  }

  camelCaseString(string) {
    let words = string.trim().split(" ");

    let result = "";

    for (let i = 0; i < words.length; i++) {
      if (words[i] !== "") {
        result =
          result +
          " " +
          words[i][0].toUpperCase() +
          words[i].substring(1).toLowerCase();
      }
    }

    return result;
  }
  onOrderSubmit(values) {
    console.log(values);

    if (!values.productId || values.productId === 0) {
      this.setState({ productError: "*Please Select Product" });
      return false;
    } else {
      this.setState({ productError: "" });
    }

    if (!values.quantity || values.quantity < 1) {
      this.setState({ quantityError: "*Quantity must be > 0" });
      return false;
    } else {
      this.setState({ quantityError: "" });
    }

    let fields = {
      name: this.camelCaseString(values.name),
      productId: values.productId,
      quantity: values.quantity,
      emailAddress: values.emailAddress,
      contactNumber: values.contactNumber,
      shippingAddress: values.shippingAddress,
      billingAddress: values.billingAddress,
    };

    ApiService.createOrder(fields)
      .then((response) => {
        this.setState({
          modal_order: !this.state.modal_order,
          modal_success: !this.state.modal_success,
          message: "Order Placed Successfully.",
        });
      })
      .catch((error) => {
        this.setState({
          modal_order: !this.state.modal_order,
          modal_failure: !this.state.modal_failure,
          message: "Something Went Wrong! Please Try Again",
        });
      });
  }

  render() {
    let {
      name,
      productId,
      quantity,
      emailAddress,
      contactNumber,
      shippingAddress,
      billingAddress,
    } = this.state;
    return (
      <div>
        <MetaTags>
          <title>
            Products | Ekathva Innovations Pvt Ltd | Agri-Tech products | Smart
            Farming, Industry 4.0, IoT products, Enterprise Softwares
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            ></meta>
          </title>
        </MetaTags>

        <Navbar />
        <LandingPageProducts />

        <div className="homepage_spacing" id="p1" ref={this.p1}>
          <br />
          <h4 data-aos="fade-right">
            <span className="aboutus_fontbold">Smart </span>Irrigation
            Controller
          </h4>
          <br />
          <div>
            <Row>
              <Col>
                <div
                  data-aos="fade-down-left"
                  className="products_carouselspacing"
                >
                  <SmartValve />
                </div>
              </Col>

              <Col data-aos="fade-left">
                <p className="products_padding">
                  <strong>
                    An IoT based device to control, schedule and micro-manage
                    the watering cycle in the irrigation,The system consists of
                    wireless controllers, valve system and mobile application
                    interface in regional languages. Increasing the efficiency
                    of irrigation by reducing the existing cost of such
                    controllers and making sure that the crops get the right
                    amount of water at the right time. Designed specially for
                    small and marginal farmers at an affordable cost, minimizing
                    the human intervention in farming.
                    <br />
                    <br />
                    {/* <p className='products_font'>Stage: MVP</p> */}
                  </strong>
                </p>
              </Col>
            </Row>
          </div>
        </div>
        <br />

        {/* <div className='aboutus_mainspace products_backgroundcolor' id='p2' ref={this.p2} >
      <br/>
      <h4 data-aos="fade-right"><span className='aboutus_fontbold'>Smart </span>Moisture Logger</h4>
      <br/>
      <div>
      <Row>
      <Col>
      <div data-aos="fade-down-left" className='products_carouselspacing'>
      <MositureLogger />
      </div>
      </Col>

      <Col data-aos="fade-left">
      <p className='products_padding' >
      <strong>
      IoT enabled, Wireless moisture data logger which measures the moisture content
      in the field and sends data periodically to the user through the means of SMS
      or analytical dashboard provided. Periodic data logging and mode of data logging
      can be controlled with the customized requirements as per the usage and conditions
      at the field.<br/><br/>
      <p className='products_font' >Stage: Prototype</p>

      </strong>
      </p>
      </Col>
      </Row>
      </div>
      </div> */}

        {/* <div  className='aboutus_mainspace' id='p3' ref={this.p3} >
      <br/>
      <h4 data-aos="fade-right"><span className='aboutus_fontbold'>D-</span>Tracker</h4>
      <br/>
      <div >
      <Row>
      <Col>
      <div data-aos="fade-down-left" className='products_carouselspacing'>
      <DTracker />
      </div>
      </Col>

      <Col data-aos="fade-left">
      <p className='products_padding' >
      <strong>
      DSCs and document tracking software for CA/CS enterprise. Helps in easy
      maintenance of important documents and DSC tokens of their clients. Keep
      track of all the client’s company documents in one platform and know the
      status of those documents just with a click of a button. Along with tracking,
      easy reminders for renewal of DSCs and other documents.
      <br/><br/>
      <p className='products_font' >Stage: MVP and Early traction</p>
      </strong>
      </p>
      </Col>
      </Row>
      </div>
      </div> */}

        {/* <div className='aboutus_mainspace products_backgroundcolor' id='p4' ref={this.p4}>
      <br/>
      <h4 data-aos="fade-right"><span className='aboutus_fontbold'>Industrial </span>Time Logger</h4>
      <br/>
      <div>
      <Row>
      <Col>
      <div data-aos="fade-down-left" className='products_carouselspacing'>
      <IndustrialTimeLogger />
      </div>
      </Col>

      <Col data-aos="fade-left">
      <p className='products_padding' >
      <strong>
      IoT enabled production line tracking and management unit for foundry.
      Includes Admin Software for data analytics and production rate tracking
      in the foundry. All the key parameters at the production line are wirelessly
      logged into the database and data analysis, data export at the admin side to
      ease the tracking of productivity and quality assurance periodically.
      <br/><br/>
      <p className='products_font' >Stage: Prototype</p>
      </strong>
      </p>
      </Col>
      </Row>
      </div>
      </div> */}

        {/* <div className='aboutus_mainspace' id='p5' ref={this.p5}>
      <br/>
      <h4 data-aos="fade-right"><span className='aboutus_fontbold'>General </span>Development Board</h4>
      <br/>
      <div>
      <Row>
      <Col>
      <div data-aos="fade-down-left" className='products_carouselspacing'>
      <GDB />
      </div>
      </Col>

      <Col data-aos="fade-left">
      <p className='products_padding' >
      <strong>
      The General Development Board consists of all the basic components or
      peripherals or modules to learn input/output operations, sensing, actuating,
      communication, and display. As the name suggests, the board is generic meaning
      it has no set microcontroller circuit. Thus, it is helpful to explore any
      microcontroller boards. It helps the user to learn the coding and debugging of
      embedded programs of many Micro-Controllers.
      </strong>
      </p>
      <br/>
      <p className='products_font' >50+ Happy customers</p>
      <Link onClick={this.toggle('order')} class="cta" style={{ textDecoration: 'none' }}>
      <span>Order Now</span>
      <svg width="13px" height="10px" viewBox="0 0 13 10">
      <path d="M1,5 L11,5"></path>
      <polyline points="8 1 12 5 8 9"></polyline>
      </svg>
      </Link>
      </Col>
      </Row>
      <br/>
      </div>
      </div> */}

        {/* <div className='aboutus_mainspace products_backgroundcolor' id='p6' ref={this.p6}>
        <br/>
        <h4 data-aos="fade-right"><span className='aboutus_fontbold'>Power </span>Supply Regulator</h4>
        <br/>
        <div>
        <Row>
        <Col>
        <div className='products_carouselspacing'>
        <PSR />
        </div>
        </Col>

        <Col data-aos="fade-left">
        <p className='products_padding' >
        <strong>
        The Power Regulator Module is an LM7805 based module, which is a DC-DC
        regulated Power Module, which gives multiple voltage levels i.e. 12V,
        5V, 3.3V. We created this board for easy and numerous access to the voltage
        from a single supply. It helps the user to draw the voltages from one device.
        </strong>
        </p>
        <br/>
        <p className='products_font' >200+ Happy customers</p>

        <Link onClick={this.toggle('order')} class="cta" style={{ textDecoration: 'none' }}>
        <span>Order Now</span>
        <svg width="13px" height="10px" viewBox="0 0 13 10">
        <path d="M1,5 L11,5"></path>
        <polyline points="8 1 12 5 8 9"></polyline>
        </svg>
        </Link>
        </Col>
        </Row>
        </div>
        </div> */}

        <Modal
          show={this.state.modal_order}
          backdrop="static"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton onClick={this.toggle("order")}>
            <Modal.Title>Place Order</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              onSubmit={this.onOrderSubmit}
              initialValues={{
                name,
                productId,
                quantity,
                emailAddress,
                contactNumber,
                shippingAddress,
                billingAddress,
              }}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize={true}
              onChange={this.handleChange}
            >
              <Form>
                <Row>
                  <Col md={2}>
                    <label>
                      Name<span className="register_page_marker">*</span>
                    </label>
                  </Col>
                  <Col md={4}>
                    <Input
                      className="capitalize"
                      name="name"
                      type="text"
                      onKeyPress={(event) => {
                        this.onKeyPressTextOnly(event);
                      }}
                      onChange={this.handleChange}
                      placeholder="Enter Your Name"
                      minLength="2"
                      maxLength="200"
                      required
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={2}>
                    <label>
                      Product<span className="register_page_marker">*</span>
                    </label>
                  </Col>
                  <Col md={4} className="text-center">
                    <select
                      className="custom-select"
                      name="productId"
                      onChange={(event) => {
                        this.handleChange(event);
                      }}
                      required
                    >
                      <option value="0">--Select--</option>
                      <option value="1">General Development Board</option>
                      <option value="2">Power Supply Regulator</option>
                    </select>
                    {this.state.productError && (
                      <Label className="errorMessage">
                        {this.state.productError}
                      </Label>
                    )}
                  </Col>
                  <Col md={2}>
                    <label>
                      Quantity<span className="register_page_marker">*</span>
                    </label>
                  </Col>
                  <Col md={4} className="text-center">
                    <Input
                      name="quantity"
                      type="number"
                      onChange={this.handleChange}
                      placeholder="Enter Quantity"
                      required
                    />
                    {this.state.quantityError && (
                      <Label className="errorMessage">
                        {this.state.quantityError}
                      </Label>
                    )}
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={2}>
                    <label>
                      Email Address
                      <span className="register_page_marker">*</span>
                    </label>
                  </Col>
                  <Col md={4} className="text-center">
                    <Input
                      name="emailAddress"
                      type="email"
                      onChange={this.handleChange}
                      placeholder="Enter Your Email"
                      onKeyPress={(event) => {
                        this.onKeyPressRetrisctSomeSC(event);
                      }}
                      maxLength="200"
                      minLength="10"
                      required
                    />
                  </Col>
                  <Col md={2}>
                    <label>
                      Contact Number
                      <span className="register_page_marker">*</span>
                    </label>
                  </Col>
                  <Col md={4} className="text-center">
                    <Input
                      name="contactNumber"
                      type="text"
                      minLength="10"
                      maxLength="10"
                      placeholder="Enter Your Contact Number"
                      onChange={this.handleChange}
                      onKeyPress={(event) => {
                        this.onKeyPressNumberOnly(event);
                      }}
                      required
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={2}>
                    <label>
                      Shipping Address
                      <span className="register_page_marker">*</span>
                    </label>
                  </Col>
                  <Col md={10} className="text-center">
                    <Input
                      placeholder="Enter Shipping Address"
                      name="shippingAddress"
                      maxLength="200"
                      type="textarea"
                      rows="2"
                      onChange={this.handleChange}
                      onKeyPress={(event) => {
                        this.onKeyPressRetrisctSomeSC(event);
                      }}
                      required
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={2}>
                    <label>
                      Billing Address
                      <span className="register_page_marker">*</span>
                    </label>
                  </Col>
                  <Col md={10} className="text-center">
                    <Input
                      placeholder="Enter Billing Address"
                      name="billingAddress"
                      maxLength="200"
                      type="textarea"
                      rows="2"
                      onChange={this.handleChange}
                      onKeyPress={(event) => {
                        this.onKeyPressRetrisctSomeSC(event);
                      }}
                      required
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={2}></Col>
                  <Col md={3}>
                    <Button variant="outline-danger" type="submit">
                      Place Order
                    </Button>
                  </Col>
                  <Col md={2}>
                    <Button
                      variant="outline-secondary"
                      type="button"
                      onClick={this.toggle("order")}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Formik>
          </Modal.Body>
        </Modal>

        {/*Success Modal */}
        <Modal
          show={this.state.modal_success}
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modal_alert"
        >
          <Modal.Body className="modalBody">
            <div className="aboutus_textalign">
              <img
                src={successImage}
                width="8%"
                alt="ekathvainnovations.com"
              ></img>
              <br />
              <br />
              <h4 className="aboutus_textalign">
                <strong> Success! </strong>
              </h4>
              <br />
              <br />
              <h6 className="aboutus_textalign">{this.state.message}</h6>
              <br />
              <Button
                type="button"
                variant="outline-danger"
                onClick={this.toggle("success")}
              >
                OK
              </Button>
            </div>
            <br />
          </Modal.Body>
        </Modal>

        {/*Failure Modal */}
        <Modal
          show={this.state.modal_failure}
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modal_alert"
        >
          <Modal.Body className="modalBody">
            <div className="aboutus_textalign">
              <img
                src={failureImage}
                width="8%"
                alt="ekathvainnovations.com"
              ></img>
              <br />
              <br />
              <h4 className="aboutus_textalign">
                <strong> Failure! </strong>
              </h4>
              <br />
              <br />
              <h6 className="aboutus_textalign">{this.state.message}</h6>
              <br />
              <Button
                type="button"
                variant="outline-danger"
                onClick={this.toggle("failure")}
              >
                OK
              </Button>
            </div>
            <br />
          </Modal.Body>
        </Modal>

        <Footer />
      </div>
    );
  }
}
export default ProductsPage;
